module.exports = __webpack_public_path__ + "static/img/potato_head.12fbb05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/collage/papercuts/potato_head.jpg
// module id = EOxb
// module chunks = 1